import { render, staticRenderFns } from "./MoveDialog.vue?vue&type=template&id=49e8f840&scoped=true"
import script from "./MoveDialog.vue?vue&type=script&lang=js"
export * from "./MoveDialog.vue?vue&type=script&lang=js"
import style0 from "./MoveDialog.vue?vue&type=style&index=0&id=49e8f840&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8f840",
  null
  
)

export default component.exports